import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/app.constants';
import { MerchantService } from '../../../services/index';
import { ExternalOrder } from '../../../models/index';

@Component({
  selector: 'shopify-data-dialog',
  templateUrl: './shopify-data-dialog.component.html',
  styleUrls: ['./shopify-data-dialog.component.css'],
})
export class ShopifyDataDialogComponent implements OnInit {
  loading = false;
  pageIndex = 0;
  pageSize = 10;
  length = 0;
  orders: ExternalOrder[] = [];
  ordersRange = '';
  error = false;
  scrollTimeout: any;
  suppressPaging: boolean = false;
  @ViewChild('myTable') table: any;

  constructor(
    public constants: Constants,
    private merchantService: MerchantService,
    public matDialogRef: MatDialogRef<ShopifyDataDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.getExternalOrders();
  }

  getExternalOrders(): void {
    this.loading = true;
    this.merchantService
      .getExternalOrders(this.pageSize, this.pageIndex, this.data.type)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.length = res.totalDocs;
            this.orders = res.docs;

            this.ordersRange = this.constants.pageCounter(
              this.pageIndex,
              this.pageSize,
              this.length,
              this.orders?.length
            );
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  get emptyString(): string {
    return `No events to display`;
  }

  pageEvent(event: any) {
    if (!this.suppressPaging) {
      this.pageIndex = event.offset;
      this.getExternalOrders();
    }
  }

  handleScroll() {
    this.suppressPaging = true;

    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.suppressPaging = false;
    }, 100);
  }
}
